import { Editor, Node, Transforms } from "slate";

/* eslint-disable no-param-reassign */
export function withSlateCopyPaste(editor: Editor): Editor {
  const { insertData } = editor;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  editor.insertData = (data: any) => {
    const slateFragment = data.getData("application/x-slate-fragment");

    if (slateFragment) {
      const fragment = JSON.parse(window.decodeURIComponent(window.atob(slateFragment)));
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      fragment.forEach((node: any) => {
        Array.from(Node.elements(node)).forEach(([element]) => {
          if (element.children.length === 0) {
            element.children = [{ text: "" }];
          }
        });
      });
      Transforms.insertFragment(editor, fragment);
      return;
    }
    insertData(data);
  };

  return editor;
}
/* eslint-enable no-param-reassign */

const PluginSpec: import("./index").PluginSpec = [withSlateCopyPaste, {}];

export default PluginSpec;
